'use client';

import Image from 'next/image';

import Modal from '@/lib/Modal';
import Button from '@/lib/Button';
import BulbImage from '@/views/SelfieKYC/TipsModal/resources/bulb.svg';
import FaceMaskImage from '@/views/SelfieKYC/TipsModal/resources/face-mask.svg';
import AlignedFaceImage from '@/views/SelfieKYC/TipsModal/resources/aligned-face.svg';

interface TipsModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

const tips = [
  {
    title: "Don't cover your face",
    description: 'Remove glasses, hat, mask, or any face coverings',
    image: FaceMaskImage as string,
  },
  {
    title: 'Find good lighting',
    description: 'Avoid face shadows by being in a well-lit area',
    image: BulbImage as string,
  },
  {
    title: 'Place your face correctly',
    description: 'Lift phone to eye level to position face at center',
    image: AlignedFaceImage as string,
  },
];

const TipsModal: React.FC<TipsModalProps> = ({ isOpen, onDismiss }) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <Modal.Body>
        <div className="d:w-1/2 d:flex d:flex-col d:items-center">
          <h2 className="font-tasa font-semibold text-2xl text-on-grey-normal">
            Tips for a clear selfie
          </h2>

          <ul className="mt-6 flex flex-col gap-4">
            {tips.map(({ title, description, image }, index) => (
              <li className="flex items-start gap-5 " key={index}>
                <div className="shrink-0 bg-surface-primary-subtle w-8 h-8 rounded-md flex items-center justify-center mt-1">
                  <Image className="m-1.5" src={image} alt={title} />
                </div>
                <div>
                  <p className="text-base font-semibold text-black-normal">{title}</p>
                  <p className="text-base text-on-grey-subtle">{description}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-7 d:w-full">
            <Button onClick={onDismiss}>Take a Photo</Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TipsModal;
